import './App.css';
import React from 'react';
import {BrowserRouter, Switch, Route, Link, Redirect} from 'react-router-dom';
import {Layout, Menu, Row, Col} from 'antd';

import GradeTable from './GradeTable';
import SemesterTable from './SemesterTable';
import CourseTable from './CourseTable';
import StudentTable from './StudentTable';
import StudentDetail from './StudentDetail';
import StudentCoursesTable from './StudentCoursesTable';



const {Header, Content} = Layout;

export default class App extends React.Component {
  render () {
    return (
      <BrowserRouter>
        <Layout>
          <Header>
            <Row justify="center">
              <Col xs={23} xl={21}>
                <Menu theme="dark" mode="horizontal" defaultSelectedKeys={[(window.location.pathname.split('/')[1] ? window.location.pathname.split('/')[1] : 'Grade')]}>
                  <Menu.Item key="Grade"><Link to="/gradesInfo">Grades</Link></Menu.Item>
                  <Menu.Item key="Semester"><Link to="/semestersInfo">Semesters</Link></Menu.Item>
                  <Menu.Item key="Course"><Link to="/coursesInfo">Courses</Link></Menu.Item>
                  <Menu.Item key="Student"><Link to="/studentsInfo">Students</Link></Menu.Item>
                </Menu>
              </Col>
            </Row>            
          </Header>

          <Content>
            <Row justify="center" className="tableTitle"> 
              <Col xs={23} xl={21}>
                <div>Student Record System</div>
              </Col>
            </Row>

            <Row>
              <Col xs={23} xl={21}>
                <Switch>
                  <Route exact path="/"><Redirect to="/gradesInfo"/></Route>
                  <Route exact path="/gradesInfo" component={GradeTable}></Route>
                  <Route exact path="/semestersInfo" component={SemesterTable}></Route>
                  <Route exact path="/coursesInfo" component={CourseTable}></Route>
                  <Route exact path="/studentsInfo" component={StudentTable}></Route>
                  <Route exact path="/studentsInfo/:id" component={StudentDetail}></Route>
                  <Route exact path="/studentsInfo/:id/selectedCourses" component={StudentCoursesTable}></Route>
                </Switch>
              </Col>
            </Row>            
          </Content>
        </Layout>      
      </BrowserRouter>
    )
  }
}